/**
 * Hardcoded maximum credit limits for card/ticket system per tenant
 * These limits represent the maximum allowed credit that can be set on a single card
 */
export const TENANT_CARD_CREDIT_LIMITS: Record<string, number> = {
  ltv: 20000,
};

export const DEFAULT_CARD_CREDIT_LIMIT = 6000;

export function getTenantCardCreditLimit(tenantId: string): number {
  return (
    TENANT_CARD_CREDIT_LIMITS[tenantId.toLowerCase()] ??
    DEFAULT_CARD_CREDIT_LIMIT
  );
}
